// extracted by mini-css-extract-plugin
module.exports = {"offerClaimRibbon":"OfferClaimRibbon_offerClaimRibbon__hg00h","svg":"OfferClaimRibbon_svg__aJUt9","claimText":"OfferClaimRibbon_claimText__4xTO4"};